import React, { Fragment , useEffect  } from "react";
import { Link, Links } from "react-router-dom";
import "core-js/stable";
import "regenerator-runtime/runtime";
import Menu from "../components/menu";
import Navbar from "../components/navbar";
import Footer from "../components/footer";
function Index(){
    useEffect(() => {
        document.title = "Home | AA_Digitals"; // Change title
    }, []);
    return(
<Fragment>
<header className="header-one sticky-header">
        <Menu></Menu>
        <Navbar></Navbar>
    </header>
    
    <section className="hero-area" id="home">
        <div className="container">
            <div className="row align-items-center justify-content-center">
                <div className="col-lg-5">
                    <div className="hero-text">
                        <span className="title-tag wow fadeInDown" data-wow-delay="0.3s">It's a lot easy to make a difference togather.</span>
                        <h2 className="title wow fadeInLeft" data-wow-delay="0.5s">We specialize in digital marketing solutions tailored to your unique<u> business needs.</u></h2>
                        <ul className="hero-btns">
                            <li className="wow fadeInUp" data-wow-delay="0.7s"><Link to="/contact" className="main-btn">Get Started Now</Link></li>
                            <li className="wow fadeInUp" data-wow-delay="0.9s"><Link to="/about" className="main-btn main-btn-2">Learn More</Link></li>
                        </ul>
                    </div>
                </div>
                <div className="col-lg-7 col-md-10">
                    <div className="hero-img text-lg-end text-center wow fadeInRight"  data-wow-delay="0.3s">
                        <img src="assets/img/banner1.png" alt="HeroImage"style={{
          border: "1px solid #000",
          borderRadius: "8px",
          boxShadow: "rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px",
        }}/>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section className="service-area section-gap" id="services">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-5">
                    <div className="section-title text-center mb-30">
                        <span className="title-tag">Our Services</span>
                        <h2 className="title">We provide wide range of digital <span>service</span></h2>
                    </div>
                </div>
            </div>

            <div className="row justify-content-center">
                <div className="col-md-6 col-sm-10 wow fadeInLeft"  data-wow-delay="0.3s">
                    <div className="service-box pro-service mt-30">
                        <div className="row align-items-center">
                            <div className="col-xl-6">
                                <div className="service-img">
                                    <img src="assets/img/branding.png" alt=""/>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="service-desc">
                                    <h4>Branding</h4>
                                    <p>
                                        Transforming bold ideas into dynamic brand experiences through innovative strategies and design.
                                    </p>
                                    <Link to="/service" className="service-link">Learn More</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-10 wow fadeInLeft"  data-wow-delay="0.3s">
                    <div className="service-box pro-service mt-30">
                        <div className="row align-items-center">
                            <div className="col-xl-6">
                                <div className="service-img">
                                    <img src="assets/img/digitalmarketing.png" alt=""/>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="service-desc">
                                    <h4>Digital Marketing</h4>
                                    <p>
                                        Elevating brands online with strategic digital marketing, captivating content, and measurable growth.
                                    </p>
                                    <Link to="/service" className="service-link">Learn More</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-10 wow fadeInRight"  data-wow-delay="0.4s">
                    <div className="service-box pro-service mt-30">
                        <div className="row align-items-center">
                            <div className="col-xl-6">
                                <div className="service-img ">
                                    <img src="assets/img/webdesign.png" alt=""/>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="service-desc">
                                    <h4>Web Design</h4>
                                    <p>
                                        Crafting responsive, elegant websites that engage audiences, build brands, and maximize impact.
                                    </p>
                                    <Link to="/service" className="service-link">Learn More</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-10 wow fadeInLeft"  data-wow-delay="0.5s">
                    <div className="service-box pro-service mt-30">
                        <div className="row align-items-center">
                            <div className="col-xl-6">
                                <div className="service-img">
                                    <img src="assets/img/seo.png" alt=""/>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="service-desc">
                                    <h4>SEO</h4>
                                    <p>
                                        Boosting search visibility with proven SEO strategies, technical optimization, and insightful analytics.
                                    </p>
                                    <Link to="/service" className="service-link">Learn More</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-10 wow fadeInRight"  data-wow-delay="0.6s">
                    <div className="service-box pro-service mt-30">
                        <div className="row align-items-center">
                            <div className="col-xl-6">
                                <div className="service-img">
                                    <img src="assets/img/graphicaldesign.png" alt=""/>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="service-desc">
                                    <h4>Graphical Design</h4>
                                    <p>
                                        Creating visually compelling designs that enhance brand identity, engage audiences, and inspire action.
                                    </p>
                                    <Link to="/service" className="service-link">Learn More</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-6 col-sm-10 wow fadeInRight"  data-wow-delay="0.6s">
                    <div className="service-box pro-service mt-30">
                        <div className="row align-items-center">
                            <div className="col-xl-6">
                                <div className="service-img">
                                    <img src="assets/img/photography.png" alt=""/>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="service-desc">
                                    <h4>Photography</h4>
                                    <p>
                                        Capturing moments with creativity, precision, and storytelling to bring visions to life.
                                    </p>
                                    <Link to="/service" className="service-link">Learn More</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="ticket-generate mt-30 wow fadeInUp">
                <p>Need Help With Your IT Endeavors? Contact Us to Get a Pro Service!</p>
                <a href="#"><i className="fal fa-ticket"></i> Generate A Ticket</a>
            </div>
        </div>
    </section>
   
    <div className="about-section section-gap" id="about">
        <div className="container">
            <div className="row align-items-center justify-content-center">
                <div className="col-lg-6 col-md-8 wow fadeInLeft">
                    <div className="about-illustration mb-md-gap-50">
                        <img src="assets/img/about banner1.png" alt=""/>
                    </div>
                </div>
                <div className="col-lg-6 col-md-10 wow fadeInRight">
                    <div className="about-text">
                        <div className="section-title mb-30">
                            <span className="title-tag">About Us</span>
                            <h2 className="title">
                                Get an amazing experience with quality level <span>team</span>
                            </h2>
                        </div>
                        <p>
                           Enjoy exceptional service from our skilled team focused on delivering top-notch results. We strive to surpass your expectations with our knowledge and meticulous approach. Count on us to enhance your project with accuracy and creativity, ensuring a smooth and impressive outcome.
                        </p>
                        <Link to="/about" className="service-link">Learn More</Link>
                       
                    </div>
                </div>
            </div>
        </div>
    </div>
 
    <section className="counter-section">
        <div className="container">
            <div className="counter-inner">
                <div className="row">
                    <div className="col-lg-3 col-sm-6">
                        <div className="counter-box">
                            <div className="counter-wrap">
                                <i className="fal fa-user"></i> <span className="counter">115</span>+
                            </div>
                            <h3 className="title" style={{color: "black"}}>Projects Executed</h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="counter-box">
                            <div className="counter-wrap">
                                <i className="fal fa-globe"></i> <span className="counter">2</span> Years
                            </div>
                            <h3 className="title"  style={{color: "black"}}>Experience</h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="counter-box">
                            <div className="counter-wrap">
                                <i className="fal fa-users"></i> <span className="counter">100</span>+
                            </div>
                            <h3 className="title"  style={{color: "black"}}>Happy Clients</h3>
                        </div>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <div className="counter-box">
                            <div className="counter-wrap">
                                <i className="fal fa-book"></i> <span className="counter">15</span>+
                            </div>
                            <h3 className="title"  style={{color: "black"}}>Team members</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section className="skill-section section-gap-top">
        <div className="container">
            <div className="row align-items-center justify-content-center justify-content-lg-between">
                <div className="col-lg-6 col-md-10">
                    <div className="skill-text mb-50">
                        <div className="section-title mb-30">
                            <span className="title-tag">Our Skillset</span>
                            <h2 className="title">Effective business delivery solutions at all <span>glance</span></h2>
                        </div>
                        <p>
                           Discover streamlined business delivery solutions for maximum efficiency. Our tailored strategies and advanced tools ensure seamless execution. Trust our expertise to enhance productivity across logistics and customer service. Experience heightened efficiency and reliability with our comprehensive solutions.
                        </p>
                    </div>
                </div>
                <div className="col-lg-5 col-md-10">
                    <div className="progress-bars mb-md-gap-60">
                        <div className="single-progress" data-count="89">
                            <div className="title">
                                <span>Work Progress</span>
                                <span className="progress-counter"><span className="count">89</span>%</span>
                            </div>
                            <div className="progressbar-wrap">
                                <div className="progressbar"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
    </section>

    <section className="testimonial-section with-pattern testimonial-brand-section" id="feedbacks">
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-lg-6">
                    <div className="section-title text-center mb-50">
                        <span className="title-tag">Testimonials</span>
                        <h2 className="title">Clients <span>feedbacks</span></h2>
                    </div>
                    <div className="testimonial-slider-progress mb-40">
                        <span className="line-one"></span>
                        <span className="line-two"></span>
                    </div>
                </div>
            </div>
            <div className="testimonial-boxes row" id="testimonialSliderOne">
                <div className="col">
                    <div className="testimonial-box">
                        <div className="author-img">
                            <img src="assets/img/testt1.png" alt="Testimonial"/>
                        </div>
                        <div className="content">
                            <p>
                                ”AA_Digitals built us a website that not only reflects our brand perfectly,  Their expertise in web design and optimization is unparalleled.”
                            </p>
                            <div className="author-info">
                                <h5>Agnes jeniffer</h5>
                                <span>business owner</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="testimonial-box">
                        <div className="author-img">
                            <img src="assets/img/testt2.png" alt="Testimonial"/>
                        </div>
                        <div className="content">
                            <p>
                                ”Choosing AA_Digitals was the best decision we made for our online growth. Their expertise and dedication are unmatched in the industry.”
                            </p>
                            <div className="author-info">
                                <h5>Maddya Begum</h5>
                                <span>Social meadia manager</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="testimonial-box">
                        <div className="author-img">
                            <img src="assets/img/testt3.png" alt="Testimonial"/>
                        </div>
                        <div className="content">
                            <p>
                                ”AA_Digitals transformed our online presence with a stunning, user-friendly website that perfectly captures our brand essence.”
                            </p>
                            <div className="author-info">
                                <h5>Jacob</h5>
                                <span>business</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col">
                    <div className="testimonial-box">
                        <div className="author-img">
                            <img src="assets/img/testt4.png" alt="Testimonial"/>
                        </div>
                        <div className="content">
                            <p>
                                ”AA_Digitals exceeded our expectations with a website that not only showcases our brand beautifully but also drives measurable results.”
                            </p>
                            <div className="author-info">
                                <h5>Merwin mathew</h5>
                                <span>business</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </section>
   
    <Footer></Footer>

</Fragment>
    )
}
export default Index;